import * as status from '../constants/replay';
export function getCurrentEventIndex(state) {
    return state.replay.currentEventIndex;
}
export function getCursorPos(state) {
    return state.replay.cursorCoords;
}
export function isRecording(state) {
    return state.replay.status === status.RECORDING;
}
export function isPlayingUserTest(state) {
    return state.replay.status === status.PLAYING;
}
